
export const ildaTabs = {
    UNASSIGNED: 'UNASSIGNED',
    TODO: 'TODO',
    MINE: 'MINE',
    ALL: 'ALL'
};